import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  TemplateRef,
} from "@angular/core";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { forkJoin, Observable } from "rxjs";

import {
  CapacitacionProgramacionService,
  CargoCapacitacion,
  CargoRecord,
} from "../../../../../shared/services/capacitaciones_programacion.service";
import {
  CapacitacionView,
  CapacitacionesService,
} from "../../../../../shared/services/capacitacion.service";
import { Utils } from "../../../../../shared/utils/Utils";
import {
  CapacitacionAsistenciaView,
  CapacitacionesAsistentesService,
} from "../../../../../shared/services/capacitacion_asistentes.service";
import { CapacitacionInvitadosService } from "../../../../../shared/services/capacitaciones_invitados.service";
import { PropietarioService } from "../../../../../shared/services/propietarios.service";
import { Administracion } from "../../../../../shared/model/administracion.model";
import { AdministracionService } from "../../../../../shared/services/administracion.services";
import { Router } from "@angular/router";

declare var require: any;
const Swal = require("sweetalert2");

interface ProgramacionView extends CargoRecord {
  capacitacion?: { nombre?: string; tema?: string };
}

interface AsistenciaRow extends CapacitacionAsistenciaView {
  estado?: number;
  capacitacion?: { nombre?: string; tema?: string };
}

@Component({
  selector: "app-capacitaciones-programacion",
  templateUrl: "./capacitaciones-programacion.component.html",
  styleUrls: ["./capacitaciones-programacion.component.scss"],
})
export class CapacitacionesProgramacionComponent implements OnInit, OnChanges {
  @Input() capacitacionId?: number | null = null;

  loading = false;
  searchText = "";
  stateFilter: "all" | "active" | "inactive" = "all";
  pageSize = 5;
  page = 1;
  sortColumn = "";
  sortDirection: "asc" | "desc" = "asc";

  programaciones: ProgramacionView[] = [];
  filteredTableItems: ProgramacionView[] = [];
  capacitaciones: CapacitacionView[] = [];

  // ── Modal único Programación (crear/editar) ──────────────────
  programacionModalRef?: NgbModalRef;
  modoEdicionProgramacion = false;
  programacionEditandoId: number | null = null;
  programacionForm: CargoRecord = this.formVacioProgramacion();
  errorProgramacion = "";

  // ── Otros modales ─────────────────────────────────────────────
  editAsistenciaModalRef?: NgbModalRef;
  asistentesModalRef?: NgbModalRef;
  agregarInvitadosModalRef?: NgbModalRef;
  createModalRef?: NgbModalRef;

  modalAsistentesTab: "asistentes" | "invitados" = "invitados";
  invitadosProgramacion: any[] = [];
  loadingInvitados = false;
  invitadosSeleccionados: any[] = [];

  filteredTableItemsAsistencia: any[] = [];
  editError = "";
  editAsistenciaId: number | null = null;
  selectedProgramacionCapacitacionId: number | null = null;
  selectedProgramacionCapacitacionNombre: string | null = null;
  selectedProgramacionId: number | null = null;
  modoEmbebido = false;
  selectedProgramacion: ProgramacionView | null = null;

  newAsistenciaForm: AsistenciaRow = this.formVacioAsistencia();
  editAsistenciaForm: AsistenciaRow = this.formVacioAsistencia();
  asistentes: any[] = [];

  public Modalidades = [
    { value: 1, label: "VIRTUAL" },
    { value: 2, label: "PRESENCIAL" },
    { value: 3, label: "HIBRIDA" },
  ];

  cedulaBuscada: string | number | null = null;
  buscandoInvitado = false;
  personaNoEncontrada = false;
  nuevoInvitadoManual: { cedula: string | number | null; nombre: string } = {
    cedula: null,
    nombre: "",
  };

  administraciones: Administracion[] = [];
  tenantId = 0;

  constructor(
    private programacionService: CapacitacionProgramacionService,
    private asistenciaService: CapacitacionesAsistentesService,
    private capacitacionesService: CapacitacionesService,
    private capacitacionInvitadosService: CapacitacionInvitadosService,
    private propietarioService: PropietarioService,
    private modalService: NgbModal,
    private administracionService: AdministracionService,
    private router: Router,
  ) {}

  // ── Ciclo de vida ────────────────────────────────────────────
  ngOnInit(): void {
    this.cargarCapacitaciones();
    this.cargarProgramaciones();
    this.cargarAdministraciones();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["capacitacionId"] && !changes["capacitacionId"].firstChange) {
      this.cargarProgramaciones();
    }
  }

  // ── Helpers de formularios vacíos ─────────────────────────────
  private formVacioProgramacion(): CargoRecord {
    return {
      capacitacion_id: undefined,
      fecha_inicio: undefined,
      fecha_final: undefined,
      modalidad: null,
      lugar: "",
      url: "",
      instructor: "",
      observaciones: "",
      estado: 1,
    };
  }

  private formVacioAsistencia(): AsistenciaRow {
    return {
      capacitacion_id: undefined,
      cedula: undefined,
      nombre: "",
      asistio: 1,
      aprobado: 0,
      calificacion: null,
      observaciones: "",
      estado: 1,
    };
  }

  // ── Helpers generales ────────────────────────────────────────
  esActivo(programacion: ProgramacionView): boolean {
    return Number(programacion?.estado ?? 1) !== 0;
  }

  // ── Carga de datos ───────────────────────────────────────────
  cargarCapacitaciones(): void {
    this.capacitacionesService.getAllCapacitacionesActivos().subscribe({
      next: (data) => {
        this.capacitaciones = (data ?? []).filter(
          (c: CapacitacionView) => Number(c.estado ?? 1) !== 0,
        );
      },
      error: () =>
        this.mostrarAlerta(
          "Error",
          "No se pudieron cargar las capacitaciones",
          "error",
        ),
    });
  }

  cargarProgramaciones(): void {
    this.loading = true;
    this.programacionService.getAllCapacitacionProgramacion().subscribe({
      next: (data) => {
        this.programaciones = data ?? [];
        this.filteredTableItems = [...this.programaciones];
        this.filterData();
        this.loading = false;
      },
      error: () => {
        this.loading = false;
        this.mostrarAlerta(
          "Error",
          "No se pudieron cargar las programaciones",
          "error",
        );
      },
    });
  }

  filterData(): void {
    const term = this.searchText.trim().toLowerCase();

    const base = this.programaciones.filter((p) => {
      if (this.stateFilter === "active") return this.esActivo(p);
      if (this.stateFilter === "inactive") return !this.esActivo(p);
      return true;
    });

    this.filteredTableItems = !term
      ? base
      : base.filter((p) => {
          const campos = [
            p.capacitacion?.nombre,
            p.capacitacion?.tema,
            p.lugar,
            p.instructor,
            String(p.id ?? ""),
            this.esActivo(p) ? "activo" : "inactivo",
          ];
          return campos.some((c) => (c ?? "").toLowerCase().includes(term));
        });

    this.sortCurrentData();
  }

  // ── Modal único: Crear / Editar Programación ─────────────────
  /**
   * Si se pasa `programacion`, abre en modo edición y carga sus datos.
   * Si no, abre en modo creación con el formulario vacío.
   */
  abrirModalProgramacion(
    content: TemplateRef<any>,
    programacion?: ProgramacionView,
  ): void {
    this.errorProgramacion = "";
    this.invitadosSeleccionados = [];
    this.cedulaBuscada = null;
    this.personaNoEncontrada = false;
    this.nuevoInvitadoManual = { cedula: null, nombre: "" };

    if (!programacion?.id) {
      this.modoEdicionProgramacion = false;
      this.programacionEditandoId = null;
      this.programacionForm = this.formVacioProgramacion();
      this.programacionModalRef = this.modalService.open(content, {
        centered: true,
        size: "xl",
        backdrop: "static",
      });
      return;
    }

    this.loading = true;
    this.programacionService
      .getCapacitacionProgramacionById(programacion.id)
      .subscribe({
        next: (data) => {
          this.loading = false;
          this.modoEdicionProgramacion = true;
          this.programacionEditandoId = Number(data.id);
          this.programacionForm = {
            capacitacion_id: data.capacitacion_id ?? undefined,
            fecha_inicio: data.fecha_inicio ?? undefined,
            fecha_final: data.fecha_final ?? undefined,
            modalidad: data.modalidad ? Number(data.modalidad) : null,
            lugar: data.lugar ?? "",
            url: data.url ?? null,
            instructor: data.instructor ?? "",
            observaciones: data.observaciones ?? "",
            estado: Number(data.estado ?? 1),
          };
          this.programacionModalRef = this.modalService.open(content, {
            centered: true,
            size: "xl",
            backdrop: "static",
          });
        },
        error: (error) => {
          this.loading = false;
          this.mostrarAlerta(
            "Error",
            error?.error?.message || "No se pudo cargar la programación",
            "error",
          );
        },
      });
  }

  /** Validación compartida entre crear y editar. Devuelve el mensaje de error o null si es válido. */
  private validarProgramacionForm(f: CargoRecord): string | null {
    if (!f.capacitacion_id) return "Seleccione la capacitación";
    if (!f.fecha_inicio) return "Ingrese la fecha de inicio";
    if (!f.fecha_final) return "Ingrese la fecha de fin";
    if (f.fecha_final < f.fecha_inicio)
      return "La fecha de fin no puede ser anterior a la fecha de inicio";
    if (!f.modalidad) return "Ingrese la modalidad";
    if ((f.modalidad === 1 || f.modalidad === 3) && !f.url?.trim())
      return "Ingrese la URL";
    if ((f.modalidad === 2 || f.modalidad === 3) && !f.lugar?.trim())
      return "Ingrese el lugar";
    if (!f.instructor) return "Ingrese el nombre del instructor";
    if (!f.observaciones) return "Ingrese las observaciones";
    return null;
  }

  private construirPayloadProgramacion(f: CargoRecord): CargoRecord {
    return {
      capacitacion_id: Number(f.capacitacion_id),
      fecha_inicio: f.fecha_inicio,
      fecha_final: f.fecha_final,
      modalidad: f.modalidad ?? null,
      lugar: f.lugar?.toUpperCase() ?? null,
      url: f.url?.trim() ?? null,
      instructor: f.instructor?.toUpperCase() ?? null,
      observaciones: f.observaciones?.trim() ?? "",
      estado: Number(f.estado ?? 1),
    };
  }

  /** Guarda la programación: crea o actualiza según `modoEdicionProgramacion`. */
  guardarProgramacion(): void {
    this.errorProgramacion = "";

    const error = this.validarProgramacionForm(this.programacionForm);
    if (error) {
      this.mostrarAlerta("Campo requerido", error, "info");
      return;
    }

    const payload = this.construirPayloadProgramacion(this.programacionForm);
    this.loading = true;

    if (this.modoEdicionProgramacion) {
      if (!this.programacionEditandoId) {
        this.loading = false;
        this.mostrarAlerta(
          "Error",
          "No se encontró la programación a editar",
          "error",
        );
        return;
      }

      this.programacionService
        .updateCapacitacionProgramacion(this.programacionEditandoId, payload)
        .subscribe({
          next: () =>
            this.finalizarGuardadoProgramacion(
              "Programación actualizada correctamente.",
            ),
          error: (err) => this.errorGuardadoProgramacion(err),
        });
      return;
    }

    this.programacionService.createCapacitacionProgramacion(payload).subscribe({
      next: (response: any) => this.crearInvitadosIniciales(response?.data?.id),
      error: (err) => this.errorGuardadoProgramacion(err),
    });
  }

  /** Tras crear la programación, registra (si hay) los invitados seleccionados en el modal. */
  private crearInvitadosIniciales(programacionId: number): void {
    if (!this.invitadosSeleccionados.length) {
      this.finalizarGuardadoProgramacion(
        "La programación se creó correctamente.",
      );
      return;
    }

    const peticiones: Observable<any>[] = this.invitadosSeleccionados.map(
      (persona: any) =>
        this.capacitacionInvitadosService.createCapacitacionInvitado({
          capacitacion_programacion_id: Number(programacionId),
          propietario_id: Number(persona.cedula),
          nombre: persona.nombre?.toUpperCase() ?? "",
          estado: 1,
        }),
    );

    forkJoin(peticiones).subscribe({
      next: () =>
        this.finalizarGuardadoProgramacion(
          "La programación y los invitados fueron creados correctamente.",
        ),
      error: (err) => {
        this.loading = false;
        this.programacionModalRef?.close();
        this.mostrarAlerta(
          "Programación creada con observaciones",
          err?.error?.message || "No se pudieron registrar algunos invitados.",
          "warning",
        );
        this.cargarProgramaciones();
      },
    });
  }

  private finalizarGuardadoProgramacion(mensaje: string): void {
    this.loading = false;
    this.programacionModalRef?.close();
    Swal.fire({
      icon: "success",
      title: this.modoEdicionProgramacion
        ? "Programación actualizada"
        : "Programación creada",
      text: mensaje,
    });
    this.cargarProgramaciones();
  }

  private errorGuardadoProgramacion(error: any): void {
    this.loading = false;
    this.mostrarAlerta(
      "No se pudo guardar la programación",
      error?.error?.message || "Revisa la información e inténtalo de nuevo.",
      "error",
    );
  }

  activarProgramacion(id: number | string | undefined): void {
    if (id == null) return;
    this.programacionService.activarCapacitacionProgramacion(id).subscribe({
      next: () => {
        Swal.fire(
          "Activada",
          "La programación fue activada correctamente.",
          "success",
        );
        this.cargarProgramaciones();
      },
      error: () =>
        this.mostrarAlerta(
          "Error",
          "No se pudo activar la programación.",
          "error",
        ),
    });
  }

  inactivarProgramacion(id: number | string | undefined): void {
    if (id == null) return;
    Swal.fire({
      title: "¿Desea inactivar esta programación?",
      text: "El registro quedará disponible en inactivos.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, inactivar",
      cancelButtonText: "Cancelar",
    }).then((result: any) => {
      if (!result.isConfirmed) return;
      this.programacionService.inactivarCapacitacionProgramacion(id).subscribe({
        next: () => {
          Swal.fire(
            "Inactivada",
            "La programación fue inactivada correctamente.",
            "success",
          );
          this.cargarProgramaciones();
        },
        error: () =>
          this.mostrarAlerta(
            "Error",
            "No se pudo inactivar la programación.",
            "error",
          ),
      });
    });
  }

  abrirModalAsistentes(id: number | string, content: TemplateRef<any>): void {
    if (!id) {
      this.mostrarAlerta(
        "Sin programación válida",
        "No se encontró un ID de programación.",
        "warning",
      );
      return;
    }
    this.loading = true;

    this.programacionService
      .getCapacitacionProgramacionByIdAsistentes(id)
      .subscribe({
        next: (data) => {
          this.loading = false;
          this.selectedProgramacionId = Number(data.id);
          this.selectedProgramacionCapacitacionId = Number(
            data.capacitacion_id,
          );
          this.selectedProgramacionCapacitacionNombre =
            data.capacitacion?.nombre ?? null;
          this.selectedProgramacion =
            this.programaciones.find((p) => Number(p.id) === Number(data.id)) ??
            null;

          this.modalAsistentesTab = "invitados";
          this.cargarAsistentesProgramacion(id);
          this.cargarInvitadosProgramacion(id);

          this.asistentesModalRef = this.modalService.open(content, {
            centered: true,
            size: "xl",
            backdrop: "static",
          });
        },
        error: (error) => {
          this.loading = false;
          this.mostrarAlerta(
            "Error",
            error?.error?.message || "No se pudo cargar la programación",
            "error",
          );
        },
      });
  }

  // ── Links de invitación ──────────────────────────────────────
  private construirLinkInvitacion(programacion: ProgramacionView): string {
    return `${window.location.origin}/Asistencia/${programacion.id}/${this.tenantId}`;
  }

  private copiarAlPortapapeles(link: string, titulo: string): void {
    const mostrarExito = () =>
      Swal.fire({
        icon: "success",
        title: titulo,
        confirmButtonColor: "#3085d6",
      });

    if (navigator.clipboard) {
      navigator.clipboard
        .writeText(link)
        .then(mostrarExito)
        .catch(() => {
          this.copiarFallback(link);
          mostrarExito();
        });
    } else {
      this.copiarFallback(link);
      mostrarExito();
    }
  }

  private copiarFallback(text: string): void {
    const el = document.createElement("textarea");
    el.value = text;
    el.style.position = "fixed";
    el.style.opacity = "0";
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
  }

  copiarLinkInvitacionProgramacion(programacion: ProgramacionView): void {
    this.copiarAlPortapapeles(
      this.construirLinkInvitacion(programacion),
      "Link de asistencia copiado",
    );
  }

  // ── Ordenamiento ─────────────────────────────────────────────
  sortData(column: string): void {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
    } else {
      this.sortColumn = column;
      this.sortDirection = "asc";
    }
    this.sortCurrentData();
  }

  private sortCurrentData(): void {
    if (!this.sortColumn) return;
    this.filteredTableItems.sort((a: any, b: any) => {
      const getVal = (item: any) =>
        this.sortColumn === "nombre"
          ? (item?.capacitacion?.nombre ?? "")
          : (item?.[this.sortColumn] ?? "");
      const vA = getVal(a).toString().toLowerCase();
      const vB = getVal(b).toString().toLowerCase();
      if (vA < vB) return this.sortDirection === "asc" ? -1 : 1;
      if (vA > vB) return this.sortDirection === "asc" ? 1 : -1;
      return 0;
    });
  }

  // ── Exportar ─────────────────────────────────────────────────
  exportToPDF(tableId: string, nameFile: string, titleFile: string): void {
    Utils.exportToPDF(tableId, nameFile, titleFile);
  }

  exportarExcel(tableId: string, nameFile: string): void {
    Utils.exportVisibleTableToExcel(tableId, nameFile);
  }

  // ── Alertas ──────────────────────────────────────────────────
  private mostrarAlerta(titulo: string, mensaje: string, icono: any): void {
    Swal.fire({
      title: titulo,
      text: mensaje,
      icon: icono,
      confirmButtonColor: "#3085d6",
    });
  }

  // ── Asistentes (sin cambios de fondo, solo reuso de helpers) ──
  asistioLabel(asistencia: AsistenciaRow): boolean {
    return Number(asistencia?.asistio ?? 0) === 1;
  }

  aprobadoLabel(asistencia: AsistenciaRow): boolean {
    return Number(asistencia?.aprobado ?? 0) === 1;
  }

  abrirModalEditarAsistente(
    asistencia: AsistenciaRow,
    content: TemplateRef<any>,
  ): void {
    if (!asistencia?.id) return;

    this.editAsistenciaModalRef = this.modalService.open(content, {
      centered: true,
      size: "xl",
      backdrop: "static",
    });
    this.editAsistenciaForm = this.formVacioAsistencia();
    this.loading = true;

    this.asistenciaService
      .getCapacitacionAsistenciaById(asistencia.id)
      .subscribe({
        next: (data: any) => {
          this.loading = false;
          this.editAsistenciaId = Number(data.id);
          this.editAsistenciaForm = {
            capacitacion_id: data.capacitacion_id ?? undefined,
            cedula: data.cedula ?? undefined,
            nombre: data.nombre ?? "",
            asistio: Number(data.asistio ?? 1),
            aprobado: Number(data.aprobado ?? 0),
            calificacion:
              data.calificacion != null ? Number(data.calificacion) : null,
            observaciones: data.observaciones ?? "",
            estado: Number(data.estado ?? 1),
          };
          this.editError = "";
        },
        error: (error) => {
          this.loading = false;
          this.editAsistenciaModalRef?.close();
          this.mostrarAlerta(
            "Error",
            error?.error?.message || "No se pudo cargar la asistencia",
            "error",
          );
        },
      });
  }

  guardarEdicionAsistencia(): void {
    this.editError = "";

    if (!this.editAsistenciaId)
      return this.mostrarAlerta(
        "Error",
        "No se encontró la asistencia a editar",
        "error",
      );
    if (!this.editAsistenciaForm.capacitacion_id)
      return this.mostrarAlerta(
        "Campo requerido",
        "Seleccione la capacitación",
        "info",
      );
    if (!this.editAsistenciaForm.cedula)
      return this.mostrarAlerta("Campo requerido", "Ingrese la cédula", "info");
    if (!this.editAsistenciaForm.nombre?.trim())
      return this.mostrarAlerta("Campo requerido", "Ingrese el nombre", "info");

    const payload: CapacitacionAsistenciaView = {
      capacitacion_id: Number(this.editAsistenciaForm.capacitacion_id),
      cedula: Number(this.editAsistenciaForm.cedula),
      nombre: this.editAsistenciaForm.nombre.trim().toUpperCase(),
      asistio: Number(this.editAsistenciaForm.asistio ?? 1),
      aprobado: Number(this.editAsistenciaForm.aprobado ?? 0),
      calificacion: this.editAsistenciaForm.calificacion ?? null,
      observaciones: this.editAsistenciaForm.observaciones?.trim() ?? "",
      estado: Number(this.editAsistenciaForm.estado ?? 1),
    };

    this.loading = true;
    this.asistenciaService
      .updateCapacitacionAsistencia(this.editAsistenciaId, payload)
      .subscribe({
        next: () => {
          if (this.selectedProgramacionId) {
            this.cargarAsistentesProgramacion(this.selectedProgramacionId);
            this.cargarInvitadosProgramacion(this.selectedProgramacionId);
          }
          this.loading = false;
          this.editAsistenciaModalRef?.close();
          Swal.fire({
            icon: "success",
            title: "Asistencia actualizada",
            text: "El registro se actualizó correctamente.",
          });
        },
        error: (error) => {
          this.loading = false;
          this.mostrarAlerta(
            "No se pudo guardar la asistencia",
            error?.error?.message ||
              "Revisa la información e inténtalo de nuevo.",
            "error",
          );
        },
      });
  }

  cargarAsistentesProgramacion(id: number | string): void {
    this.programacionService
      .getCapacitacionProgramacionByIdAsistentes(id)
      .subscribe({
        next: (data) => {
          this.asistentes = data.asistentes ?? [];
          this.filteredTableItemsAsistencia = [...this.asistentes];
        },
        error: () =>
          this.mostrarAlerta(
            "Error",
            "No se pudieron actualizar los asistentes",
            "error",
          ),
      });
  }

  cargarInvitadosProgramacion(id: number | string): void {
    this.loadingInvitados = true;
    this.capacitacionInvitadosService
      .getCapacitacionInvitadoById(id)
      .subscribe({
        next: (data) => {
          this.loadingInvitados = false;
          this.invitadosProgramacion = data ?? [];
        },
        error: () => {
          this.loadingInvitados = false;
          this.mostrarAlerta(
            "Error",
            "No se pudieron cargar los invitados.",
            "error",
          );
        },
      });
  }

  abrirModalAgregarInvitados(content: TemplateRef<any>): void {
    if (!this.selectedProgramacionId) return;
    this.invitadosSeleccionados = [];
    this.cedulaBuscada = null;
    this.personaNoEncontrada = false;
    this.nuevoInvitadoManual = { cedula: null, nombre: "" };
    this.agregarInvitadosModalRef = this.modalService.open(content, {
      centered: true,
      size: "xl",
      backdrop: "static",
    });
  }

  guardarNuevosInvitados(): void {
    if (!this.selectedProgramacionId)
      return this.mostrarAlerta(
        "Error",
        "No se encontró la programación seleccionada",
        "error",
      );
    if (!this.invitadosSeleccionados?.length)
      return this.mostrarAlerta(
        "Campo requerido",
        "Seleccione al menos un invitado",
        "info",
      );

    const programacionId = this.selectedProgramacionId;
    const peticiones = this.invitadosSeleccionados.map((inv) =>
      this.capacitacionInvitadosService.createCapacitacionInvitado({
        capacitacion_programacion_id: Number(programacionId),
        propietario_id: inv.cedula,
        nombre: inv.nombre,
        estado: 1,
      }),
    );

    this.loading = true;
    forkJoin(peticiones).subscribe({
      next: () => {
        this.loading = false;
        this.agregarInvitadosModalRef?.close();
        Swal.fire({
          icon: "success",
          title: "Invitados agregados",
          text: "Los invitados se agregaron correctamente.",
        });
        this.cargarInvitadosProgramacion(programacionId);
        this.invitadosSeleccionados = [];
      },
      error: (error) => {
        this.loading = false;
        this.cargarInvitadosProgramacion(programacionId);
        this.mostrarAlerta(
          "No se pudieron agregar algunos invitados",
          error?.error?.message ||
            "Revisa la información e inténtalo de nuevo.",
          "error",
        );
      },
    });
  }

  quitarInvitado(invitado: any): void {
    if (!invitado?.id) return;
    Swal.fire({
      title: "¿Desea quitar este invitado?",
      text: "El invitado dejará de estar asociado a esta programación.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, quitar",
      cancelButtonText: "Cancelar",
    }).then((result: any) => {
      if (!result.isConfirmed) return;
      this.capacitacionInvitadosService.inactivar(invitado.id).subscribe({
        next: () => {
          Swal.fire(
            "Invitado removido",
            "El invitado fue removido correctamente.",
            "success",
          );
          if (this.selectedProgramacionId)
            this.cargarInvitadosProgramacion(this.selectedProgramacionId);
        },
        error: () =>
          this.mostrarAlerta(
            "Error",
            "No se pudo quitar el invitado.",
            "error",
          ),
      });
    });
  }

  abrirModalNuevoAsistente(content: TemplateRef<any>): void {
    this.newAsistenciaForm = {
      ...this.formVacioAsistencia(),
      capacitacion_id: this.selectedProgramacionId ?? undefined,
    };
    this.createModalRef = this.modalService.open(content, {
      centered: true,
      size: "xl",
      backdrop: "static",
    });
  }

  guardarNuevaAsistencia(): void {
    if (!this.newAsistenciaForm.capacitacion_id)
      return this.mostrarAlerta(
        "Campo requerido",
        "Seleccione la capacitación",
        "info",
      );
    if (!this.newAsistenciaForm.cedula)
      return this.mostrarAlerta("Campo requerido", "Ingrese la cédula", "info");
    if (!this.newAsistenciaForm.nombre?.trim())
      return this.mostrarAlerta("Campo requerido", "Ingrese el nombre", "info");

    const payload: CapacitacionAsistenciaView = {
      capacitacion_id: Number(this.newAsistenciaForm.capacitacion_id),
      cedula: Number(this.newAsistenciaForm.cedula),
      nombre: this.newAsistenciaForm.nombre.trim().toUpperCase(),
      asistio: Number(this.newAsistenciaForm.asistio ?? 1),
      aprobado: Number(this.newAsistenciaForm.aprobado ?? 0),
      calificacion: this.newAsistenciaForm.calificacion ?? null,
      observaciones: this.newAsistenciaForm.observaciones?.trim() ?? "",
      estado: Number(this.newAsistenciaForm.estado ?? 1),
    };

    this.loading = true;
    this.asistenciaService.createCapacitacion(payload).subscribe({
      next: () => {
        this.loading = false;
        this.cargarAsistentesProgramacion(
          this.selectedProgramacionId as number,
        );
        this.createModalRef?.close();
        this.cargarInvitadosProgramacion(this.selectedProgramacionId as number);
        Swal.fire({
          icon: "success",
          title: "Asistencia creada",
          text: "El registro de asistencia se creó correctamente.",
        });
      },
      error: (error) => {
        this.loading = false;
        this.mostrarAlerta(
          "No se pudo guardar la asistencia",
          error?.error?.message ||
            "Revisa la información e inténtalo de nuevo.",
          "error",
        );
      },
    });
  }

  // ── Búsqueda de invitados ────────────────────────────────────
  buscarInvitadoPorCedula(): void {
    const cedula = String(this.cedulaBuscada ?? "").trim();
    if (!cedula) return;

    if (
      this.invitadosSeleccionados.some((inv) => String(inv.cedula) === cedula)
    ) {
      return this.mostrarAlerta(
        "Aviso",
        "Esta persona ya fue agregada",
        "info",
      );
    }

    this.personaNoEncontrada = false;
    this.buscandoInvitado = true;

    this.propietarioService.getCedulaPesv(cedula).subscribe({
      next: (res: any) => {
        this.buscandoInvitado = false;
        const propietario = res?.propietario;

        if (!propietario?.cedula) return this.activarAgregarManual(cedula);

        const nombreCompleto = [
          propietario.primernombre,
          propietario.segundonombre,
          propietario.papellidos,
          propietario.seapellidos,
        ]
          .map((p: string) => (p ?? "").trim())
          .filter((p: string) => !!p)
          .join(" ");

        this.invitadosSeleccionados.push({
          cedula: propietario.cedula,
          nombre: nombreCompleto,
        });
        this.cedulaBuscada = null;
      },
      error: () => {
        this.buscandoInvitado = false;
        this.activarAgregarManual(cedula);
      },
    });
  }

  private activarAgregarManual(cedula: string): void {
    this.personaNoEncontrada = true;
    this.nuevoInvitadoManual = { cedula, nombre: "" };
  }

  agregarInvitadoManual(): void {
    const cedula = String(this.nuevoInvitadoManual.cedula ?? "").trim();
    const nombre = this.nuevoInvitadoManual.nombre?.trim();

    if (!cedula)
      return this.mostrarAlerta("Campo requerido", "Ingrese la cédula", "info");
    if (!nombre)
      return this.mostrarAlerta("Campo requerido", "Ingrese el nombre", "info");
    if (
      this.invitadosSeleccionados.some((inv) => String(inv.cedula) === cedula)
    ) {
      return this.mostrarAlerta(
        "Aviso",
        "Esta persona ya fue agregada",
        "info",
      );
    }

    this.invitadosSeleccionados.push({ cedula, nombre: nombre.toUpperCase() });
    this.personaNoEncontrada = false;
    this.cedulaBuscada = null;
    this.nuevoInvitadoManual = { cedula: null, nombre: "" };
  }

  cancelarAgregarManual(): void {
    this.personaNoEncontrada = false;
    this.nuevoInvitadoManual = { cedula: null, nombre: "" };
  }

  eliminarInvitado(cedula: number | string): void {
    this.invitadosSeleccionados = this.invitadosSeleccionados.filter(
      (inv) => String(inv.cedula) !== String(cedula),
    );
  }

  cargarAdministraciones(): void {
    this.administracionService.obtenerTodas().subscribe({
      next: (data) => {
        this.administraciones = data || [];
        if (this.administraciones.length > 0)
          this.tenantId = this.administraciones[0].consumidas;
      },
      error: (err) =>
        this.mostrarAlerta(
          "Error",
          err.message || "No se pudo cargar la configuración.",
          "error",
        ),
    });
  }

  verActividades(cargoCapacitacion: CargoCapacitacion): void {
    Swal.fire({
      title: "Crear actividades",
      text: `¿Desea ver los actividades para el programa ${cargoCapacitacion.capacitacion_id}?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Sí, Ver",
      cancelButtonText: "Cancelar",
    }).then((result: any) => {
      if (result.isConfirmed) {
        this.router.navigate([
          "/capacitacion-actividades/capacitacion-actividades",
          cargoCapacitacion.id,
        ]);
      }
    });
  }


get totalProgramaciones(): number {
  return this.programaciones.length;
}

get totalProgramacionesActivas(): number {
  return this.programaciones.filter((p) => this.esActivo(p)).length;
}

get proximaProgramacion(): ProgramacionView | undefined {
  const hoy = new Date();
  hoy.setHours(0, 0, 0, 0);

  return [...this.programaciones]
    .filter((p) => this.esActivo(p) && p.fecha_inicio)
    .map((p) => ({ item: p, fecha: new Date(p.fecha_inicio as any) }))
    .filter((x) => x.fecha.getTime() >= hoy.getTime())
    .sort((a, b) => a.fecha.getTime() - b.fecha.getTime())[0]?.item;
}

  verAsistentes(cargoCapacitacion: CargoCapacitacion): void {
    Swal.fire({
      title: "Ver Asistentes",
      text: `¿Desea ver los asistentes para el programa ${cargoCapacitacion.capacitacion_id}?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Sí, Ver",
      cancelButtonText: "Cancelar",
    }).then((result: any) => {
      if (result.isConfirmed) {
        this.router.navigate([
          "/capacitacion/asistentes",
          cargoCapacitacion.id,
        ]);
      }
    });
  }
}